export default __webpack_public_path__ + "static/media/bg-info-event.d08c3025.png";